<template>
  <Modal :open="open" @close="close">
    <div>
      <div class="text-center">
        <h2 class="text-lg font-semibold text-gray-900">Modifier le type du sinistre</h2>
      </div>

      <div class="mb-6">
        <Selector
          id="claimType"
          name="claimType"
          v-model="claimType"
          label="Type du sinistre"
          label-class="block text-sm font-medium leading-6 text-gray-900"
          :required="true"
          :options="claimTypeOptions"
          default-option-text="Sélectionner un type de sinistre"
        />
      </div>

      <div class="flex justify-center space-x-4">
        <SecondaryButton @click="handleUpdateClaimType">Confirmer</SecondaryButton>
      </div>
    </div>
  </Modal>
</template>

<script>
import { Modal, SecondaryButton, Selector } from "@estaly/ui";
import { mapActions, mapGetters } from "vuex";

export default {
  components: {
    Modal,
    SecondaryButton,
    Selector,
  },

  props: {
    open: {
      type: Boolean,
      required: true,
    },
    claim: {
      type: Object,
      required: true,
    },
  },

  data() {
    return {
      claimType: null,
    };
  },

  computed: {
    ...mapGetters("claims", ["claimTypes"]),

    claimTypeOptions() {
      return this.claimTypes().map((type) => ({
        value: type,
        label: this.$t(`claim.claim_type.${type}`),
      }));
    },
  },

  methods: {
    ...mapActions("claims", ["updateClaim"]),
    ...mapActions("notifications", ["notify"]),

    async handleUpdateClaimType() {
      const response = await this.updateClaim({ claimType: this.claimType });

      if (!response?.success) return;

      this.notify({
        category: "simple",
        type: "success",
        title: "Dossier sinistre modifié avec succès",
      });
      this.close();
    },

    close() {
      this.$emit("close");
    },
  },

  watch: {
    open(newVal) {
      if (newVal) {
        this.claimType = this.claim?.claimType || null;
      }
    },
  },
};
</script>
